import { motion } from 'framer-motion';
import React from 'react';
import { heroAnimations } from '../../utils/heroAnimation';
import { BRAND_COLORS } from '../../constants/feedback';

interface AnimatedTextProps {
  text: string;
  isWave?: boolean;
  letterSpacing?: string;
  isLongText?: boolean;
}

const getRandomColor = () => {
  const colors = Object.values(BRAND_COLORS);
  return colors[Math.floor(Math.random() * colors.length)];
};

const createLetterVariants = (delay: number) => ({
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    color: getRandomColor(),
    transition: { delay: delay * 0.05 }, // Faster animation for longer text
  },
});

const createWaveLetterVariants = (delay: number) => ({
  hidden: { y: 50, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    color: getRandomColor(),
    transition: {
      type: 'spring',
      stiffness: 200,
      damping: 10,
      delay: delay * 0.05, // Faster animation for longer text
    },
  },
});

export const AnimatedText: React.FC<AnimatedTextProps> = ({
  text,
  isWave = false,
  letterSpacing = '0.1em',
}) => (
  <motion.span
    variants={isWave ? heroAnimations.waveText : heroAnimations.word}
    initial="hidden"
    animate="visible"
    className={`${
      isWave ? '' : 'font-bold'
    } inline-flex flex-wrap justify-center text-[10px] sm:text-sm md:text-base`}
    style={{ gap: letterSpacing }}
  >
    {[...text].map((char, index) => (
      <motion.span
        key={index}
        variants={
          isWave ? createWaveLetterVariants(index) : createLetterVariants(index)
        }
        className="inline-block"
      >
        {char === ' ' ? '\u00A0' : char}
      </motion.span>
    ))}
  </motion.span>
);
